import ResultsInventionDisclosure from './resultsInventionDisclosure.js';
export default ResultsInventionDisclosure;
